/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Checkup } from '../models/Checkup';
import type { DcdOwnershipSyncTriggerResponse } from '../models/DcdOwnershipSyncTriggerResponse';
import type { RoadmapSyncTriggerMode } from '../models/RoadmapSyncTriggerMode';
import type { RoadmapSyncTriggerResponse } from '../models/RoadmapSyncTriggerResponse';
import type { ServiceNowContentSyncResponse } from '../models/ServiceNowContentSyncResponse';
import type { ServiceNowCredentialsResponse } from '../models/ServiceNowCredentialsResponse';
import type { TaskStatusResponse } from '../models/TaskStatusResponse';
import type { UpdateEmployeesResponse } from '../models/UpdateEmployeesResponse';
import type { WorkstreamMetricSnapshotTriggerResponse } from '../models/WorkstreamMetricSnapshotTriggerResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ToolsService {

    /**
     * Team Endpoint
     * @param id
     * @returns Checkup Successful Response
     * @throws ApiError
     */
    public static teamAuditApiV1AuditToolIdGet(
        id: string,
    ): CancelablePromise<Checkup> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/audit/tool/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Csv
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportCsvApiV1AuditTeamCsvGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/audit/team/csv',
        });
    }

    /**
     * Update Employees
     * @returns UpdateEmployeesResponse Successful Response
     * @throws ApiError
     */
    public static updateEmployeesApiV1ToolUpdateEmployeesPut(): CancelablePromise<UpdateEmployeesResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/tool/update_employees',
        });
    }

    /**
     * Update Employees Status
     * @param taskId
     * @returns UpdateEmployeesResponse Successful Response
     * @throws ApiError
     */
    public static getUpdateEmployeesStatusApiV1ToolUpdateEmployeesTaskIdGet(
        taskId: string,
    ): CancelablePromise<UpdateEmployeesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tool/update_employees/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Trigger Roadmap Sync
     * Queue an incremental sync or complete Roadmap source rebuild.
     * @param mode
     * @returns RoadmapSyncTriggerResponse Successful Response
     * @throws ApiError
     */
    public static triggerRoadmapSyncApiV1ToolRoadmapSyncModePost(
        mode: RoadmapSyncTriggerMode,
    ): CancelablePromise<RoadmapSyncTriggerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tool/roadmap_sync/{mode}',
            path: {
                'mode': mode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Trigger Workstream Metric Snapshot
     * Queue a manual WorkstreamMetric snapshot for today's UTC date.
     * @returns WorkstreamMetricSnapshotTriggerResponse Successful Response
     * @throws ApiError
     */
    public static triggerWorkstreamMetricSnapshotApiV1ToolWorkstreamMetricSnapshotsPost(): CancelablePromise<WorkstreamMetricSnapshotTriggerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tool/workstream_metric_snapshots',
        });
    }

    /**
     * Trigger DCD Ownership Sync
     * Queue a DCD ownership sync.
     * @returns DcdOwnershipSyncTriggerResponse Successful Response
     * @throws ApiError
     */
    public static triggerDcdOwnershipSyncApiV1ToolDcdOwnershipSyncPost(): CancelablePromise<DcdOwnershipSyncTriggerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tool/dcd_ownership_sync',
        });
    }

    /**
     * Queued Task Status
     * Return the status of a task queued from the admin Tasks page.
     *
     * On success, the message lists the result's top-level scalar fields
     * (counts, modes) and drops nested payloads.
     * @param taskId
     * @returns TaskStatusResponse Successful Response
     * @throws ApiError
     */
    public static getTaskStatusApiV1ToolTaskStatusTaskIdGet(
        taskId: string,
    ): CancelablePromise<TaskStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tool/task_status/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Check ServiceNow Credentials
     * Verify current-environment ServiceNow access without syncing content.
     * @returns ServiceNowCredentialsResponse Successful Response
     * @throws ApiError
     */
    public static checkServicenowCredentialsApiV1ToolCheckServicenowCredentialsPost(): CancelablePromise<ServiceNowCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tool/check_servicenow_credentials',
        });
    }

    /**
     * Trigger ServiceNow Content Sync
     * Queue a ServiceNow taxonomy and article metadata sync.
     * @returns ServiceNowContentSyncResponse Successful Response
     * @throws ApiError
     */
    public static triggerServicenowContentSyncApiV1ToolServicenowContentSyncPost(): CancelablePromise<ServiceNowContentSyncResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tool/servicenow_content_sync',
        });
    }

    /**
     * ServiceNow Content Sync Status
     * Return the status of a previously queued ServiceNow content sync.
     * @param taskId
     * @returns ServiceNowContentSyncResponse Successful Response
     * @throws ApiError
     */
    public static getServicenowContentSyncStatusApiV1ToolServicenowContentSyncTaskIdGet(
        taskId: string,
    ): CancelablePromise<ServiceNowContentSyncResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/tool/servicenow_content_sync/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
